import Immutable from 'immutable';

const EMPTY_MAP = Immutable.Map({});
const EMPTY_LIST = Immutable.List([]);

const yesCallback = () => true;

const EMPTY_STATE = Immutable.fromJS({
	__module: 'ModuleSelector',
	data: {
	}
});


function processFolderStructure(folder, isVisible) {
	const items = folder.items.filter(isVisible).map(item => {
		return {
			name: item.name,
			text: item.text,
			icon: item.icon
		}
	});
	if (items.length === 0) {
		return null;
	}
	return {
		name: folder.name,
		text: folder.text,
		icon: folder.icon,
		items
	}
}

function processFolderModules(modules, folders, isVisible) {
	folders.filter(isVisible).forEach(folder => {
		modules[folder.name] = modules[folder.name] || {};
		folder.items.filter(isVisible).forEach(item => {
			const model = item.model;
			if (model) {
				modules[folder.name][item.name] = model.getState();
			}
		});
	});
}

export default class ModuleSelectorModel {
	#data;

	constructor(data = null) {
		this.#data = data || EMPTY_MAP;
	}

	setFolders(folders, isVisible) {
		isVisible = isVisible || yesCallback;

		let modules = {};
		processFolderModules(modules, folders, isVisible);
		folders = Immutable.fromJS(folders.filter(isVisible).map(folder => processFolderStructure(folder, isVisible)).filter(Boolean));
		return new ModuleSelectorModel(this.#data.set('folders', folders).set('modules', Immutable.fromJS(modules)));
	}

	toggleModuleSelectorVisibility() {
		return new ModuleSelectorModel(this.#data.set('moduleSelectorHidden', !this.#data.get('moduleSelectorHidden')));
	}

	setSelectedItem(folderName, itemName) {
		return new ModuleSelectorModel(this.#data.set('selectedFolderName', folderName).set('selectedItemName', itemName));
	}

	setExpandedFolder(folderName) {
		return new ModuleSelectorModel(this.#data.set('expandedFolderName', folderName));
	}

	setModuleData(folderName, itemName, data) {
		return new ModuleSelectorModel(this.#data.setIn(['modules', folderName, itemName, 'data'], data));
	}

	getData() {
		return this.#data;
	}

	getState() {
		return EMPTY_STATE.set('data', this.#data);
	}
}
